(function () {
	'use strict';

	angular
		.module('app')
		.config(configure);

	configure.$inject = ['$experimentsProvider', '$stateProvider', '$urlRouterProvider', '$translateProvider',
		'$httpProvider', 'cfpLoadingBarProvider', '$qProvider', '$locationProvider'
	];

	function configure( $experimentsProvider, $stateProvider, $urlRouterProvider, $translateProvider,
			$httpProvider, cfpLoadingBarProvider, $qProvider, $locationProvider) {
		$qProvider.errorOnUnhandledRejections(false);
		$locationProvider.hashPrefix('');
		$httpProvider.interceptors.push('httpErrorInterceptor');
		$httpProvider.useApplyAsync(true);
		$urlRouterProvider.otherwise(function ($injector) {
			return $injector.get('navigationService').getFirstPermittedPath() || '/dashboard/list/0';
		});
		if (!$httpProvider.defaults.headers.get) {
			$httpProvider.defaults.headers.get = {};
		}
		$httpProvider.defaults.headers.get['If-Modified-Since'] = '0';
		cfpLoadingBarProvider.includeBar = false;

		$translateProvider.useStaticFilesLoader({
			prefix: '/api/2/factndx/' + globalConfig.factory.id + '/I18N/Locale/',
			suffix: '.json'
		});
		$translateProvider.determinePreferredLanguage(function () {
			var preferredLangKey = globalConfig.browser.locale;
			preferredLangKey = (preferredLangKey || '').split('-').join('_').toLowerCase();
			return preferredLangKey;
		});
		$translateProvider.useSanitizeValueStrategy();
		$translateProvider.forceAsyncReload(true);
		$translateProvider.fallbackLanguage('en_us');
		$translateProvider.translations('en_us', {
			'accountSettings.bulkUpdate.modal.title': 'Updating account settings',
			'accountSettings.bulkUpdate.modal.body': 'By updating the company row, all site rows will be updated. Are you sure?',
			'accountSettings.bulkUpdate.modal.confirm': 'Update settings',
			'supplyOrder.upload.modal.body.upload.limit': 'There is an upload limit of {{noOfRows}} rows at a time. If you need to upload more than {{noOfRows}} rows, you will need to split them into multiple files and upload one at a time.',
			'productionOrder.upload.modal.body.upload.limit': 'There is an upload limit of {{noOfRows}} rows at a time. If you need to upload more than {{noOfRows}} rows, you will need to split them into multiple files and upload one at a time.',
			'Shortage Criticality': 'Shortage criticality',
			'leanTable.editor.inventoryAction.unableToFixCategory': 'Unable to fix category',
			'leanTable.editor.inventoryAction.chooseCategory': 'Choose category',
			'leanTable.editor.inventoryAction.addCommentRequired': 'Add Comment (required)',
			'leanTable.editor.inventoryAction.addCommentOptional': 'Add Comment (optional)',
			'leanTable.editor.inventoryAction.commentReason': 'Reason this cannot be fixed...',
			'leanTable.editor.inventoryAction.commentReasonRequired': "Comment on why this can't be done",
			'leanTable.editor.inventoryAction.reassign': 'Reassign'
		});

		$stateProvider
			.state('app', {
				abstract: true,
				url: '/',
				views: {
					'header@': {
						templateUrl: 'header.html',
						controller: 'headerNavigation'
					}
				},
				data: {
					pdateTitle: 'LeanDNA Dashboard'
				}
			})
			// **************  DASHBOARD START ************** //
			.state('app.dashboard', {
				abstract: true,
				url: 'dashboard?pendo'
			})
			.state('app.dashboard.home', {
				url: '/{id}',
				views: {
					'main@': {
						templateUrl: 'dashboard/home.html',
						controller: 'dashboardMainCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Dashboard',
					timingName: 'Dashboard',
					doTiming: true
				}
			})
			.state('app.dashboard.list', {
				url: '/list/{id}',
				views: {
					'main@': {
						templateUrl: 'dashboard/dashboard-list.html'
					}
				},
				params: {
					id: { squash: true, value: null }
				}
			})
			.state('app.dashboard.create', {
				url: '/create/{id}',
				views: {
					'main@': {
						templateUrl: 'dashboard/dashboard-create.html'
					}
				},
				params: {
					id: { squash: true, value: null }
				}
			})
			.state('app.dashboard.buyer-performance', {
				url: '/perf/buyer/:id',
				params: {
					id: { squash: true, value: null }
				},
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							var params = $location.search();
							params.reportId = $state.params.id;

							$state.go('app.supply-chain.buyer-performance', params);
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.dashboard.site-performance', {
				url: '/perf/site/:id',
				params: {
					id: { squash: true, value: null }
				},
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							var params = $location.search();
							params.reportId = $state.params.id;

							$state.go('app.supply-chain.site-performance', params);
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.dashboard.planner-performance-single-level', {
				url: '/perf/planner-single-level/:id',
				params: {
					id: { squash: true, value: null }
				},
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							var params = $location.search();
							params.reportId = $state.params.id;

							$state.go('app.supply-chain.planner-performance-single-level', params);
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.dashboard.planner-performance-multi-level', {
				url: '/perf/planner-multi-level/:id',
				params: {
					id: { squash: true, value: null }
				},
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							var params = $location.search();
							params.reportId = $state.params.id;

							$state.go('app.supply-chain.planner-performance-multi-level', params);
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.dashboard.item-group-performance', {
				url: '/perf/item-group/:id',
				params: {
					id: { squash: true, value: null }
				},
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							var params = $location.search();
							params.reportId = $state.params.id;
							$state.go('app.supply-chain.item-group-performance', params);
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.dashboard.quicksight', {
				url: '/perf/data-health/{id}',
				views: {
					'main@': {
						templateUrl: 'dashboard/quicksight-dashboard.html',
						controller: 'quickSightDashboard as tableCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Dashboard',
					timingName: 'Dashboard',
					doTiming: true
				}
			})
			.state('app.dashboard.superset', {
				url: '/perf/superset/{id}',
				views: {
					'main@': {
						templateUrl: 'dashboard/superset-dashboard.html',
						controller: 'supersetDashboard as tableCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Dashboard',
					timingName: 'Dashboard',
					doTiming: true
				}
			})
			.state('app.dashboard.business-analytics', {
				url: '/ba/{id}',
				views: {
					'main@': {
						templateUrl: 'dashboard/business-analytics.html'
					}
				},
				data: {
					pageTitle: 'LeanDNA Dashboard'
				}
			})
			// **************  DASHBOARD END ************** //
			// **************  My Work START ************** //
			.state('app.my-work', {
				abstract: true,
				url: 'my-work'
			})
			.state('app.my-work.my-inventory-opportunities', {
				url: '/my-inventory-opportunities/:reportId',
				views: {
					'main@': {
						templateUrl: 'my-work/my-inventory-opportunities.html',
						controller: 'myInventoryOpportunities'
					}
				},
				params: {
					reportId: { squash: true, value: null }
				},
				data: {
					pageTitle: 'LeanDNA My Work Inventory Opportunities',
					viewType: 'myInventoryOpportunities'
				}
			})
			.state('app.my-work.my-project-tasks', {
				url: '/my-project-tasks/:reportId',
				views: {
					'main@': {
						templateUrl: 'my-work/my-project-tasks.html',
						controller: 'myProjectTasks'
					}
				},
				params: {
					reportId: { squash: true, value: null }
				},
				data: {
					pageTitle: 'LeanDNA My Work Project Tasks',
					viewType: 'projectTasks'
				}
			})
			.state('app.my-work.strategic-sourcing', {
				url: '/strategic-sourcing/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'strategicSourcing as tableCtrl'
					}
				},
				params: {
					reportId: { squash: true, value: null }
				},
				data: {
					pageTitle: 'LeanDNA Strategic Sourcing',
					viewType: 'strategicSourcing',
					timingName: 'StrategicSourcing'
				}
			})
			// **************  My Work END ************** //
			// **************  Inbox START ************** //
			.state('app.chat-inbox', {
				url: 'chat-inbox?drilldownSettings&factoryNdx&byEmail&emailType',
				views: {
					'left@': null,
					'main@': {
						templateUrl: 'my-work/chat-inbox.html'
					}
				},
				data: {
					pageTitle: 'LeanDNA Chat Inbox',
					timingName: 'Chat Inbox'
				}
			})
			// **************  Inbox END ************** //
			// **************  FACTORY START ************** //
			.state('app.factory', {
				abstract: true,
				url: 'factory'
			})
			.state('app.factory.report-card', {
				url: '/report-card',
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.lean-projects.report-card', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			// **************  FACTORY END 	************** //
			// **************  User achievements START ************** //
			.state('app.user-achievements', {
				abstract: true,
				url: 'user-achievements'
			})
			.state('app.user-achievements.board', {
				url: '/board',
				views: {
					'main@': {
						templateUrl: 'core/user-achievement/user-achievement.html'
					}
				},
				data: {
					pageTitle: 'LeanDNA User achievements board',
					viewType: 'user-achievements'
				}
			})
			// **************  User achievements END 	************** //
			// **************  KEI AI START 	************** //
			.state('app.kei-ai', {
				url: 'kei-ai',
				views: {
					'main@': {
						templateUrl: 'core/kei-ai/kei-ai.html'
					}
				}, 
				data: {
					pageTitle: 'LeanDNA Kei AI',
					viewType: 'kei-ai'
				}
			})
			.state('app.kei-ai.conversations', {
				url: '/conversations',
				views: {
					'main@': {
						templateUrl: 'core/kei-ai/kei-ai-conversations.html'
					}
				}, 
				data: {
					pageTitle: 'LeanDNA Kei AI Conversations',
					viewType: 'kei-ai'
				}
			})
			// **************  KEI AI END 	************** //
			// **************  SUPPLY CHAIN START ************** //
			.state('app.supply-chain', {
				abstract: true,
				url: 'supply-chain'
			})
			.state('app.supply-chain.buyer-performance', {
				url: '/buyer-performance/:reportId?drilldown&emailType&byEmail&factoryNdx&factory&drilldownSettings',
				views: {
					'main@': {
						templateUrl: 'dashboard/supply-chain-performance.html'
					}
				},
				params: {
					reportId: { squash: true, value: null }
				}
			})
			.state('app.supply-chain.site-performance', {
				url: '/site-performance/:reportId?drilldown&emailType&byEmail&factoryNdx&factory',
				views: {
					'main@': {
						templateUrl: 'dashboard/supply-chain-performance.html'
					}
				},
				params: {
					reportId: { squash: true, value: null }
				}
			})
			.state('app.supply-chain.planner-performance-single-level', {
				url: '/planner-performance-single-level/:reportId?drilldown&emailType&byEmail&factoryNdx&factory',
				views: {
					'main@': {
						templateUrl: 'dashboard/supply-chain-performance.html'
					}
				},
				params: {
					reportId: { squash: true, value: null }
				}
			})
			.state('app.supply-chain.planner-performance-multi-level', {
				url: '/planner-performance-multi-level/:reportId?drilldown&emailType&byEmail&factoryNdx&factory',
				views: {
					'main@': {
						templateUrl: 'dashboard/supply-chain-performance.html'
					}
				},
				params: {
					reportId: { squash: true, value: null }
				}
			})
			.state('app.supply-chain.item-group-performance', {
				url: '/item-group-performance/:reportId?drilldown&emailType&byEmail&factoryNdx&factory',
				views: {
					'main@': {
						templateUrl: 'dashboard/supply-chain-performance.html'
					}
				},
				params: {
					reportId: { squash: true, value: null }
				}
			})
			.state('app.supply-chain.redirects', {
				abstract: true
			})
			.state('app.supply-chain.redirects.burnoff', {
				url: '/burnoff',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.inventory-burnoff', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.report-list', {
				url: '/report-list',
				views: {
					'main@': {
						templateUrl: 'supply-chain/reports/report-list.html'
					}
				}
			})
			.state('app.supply-chain.favorites', {
				url: '/favorites',
				views: {
					'main@': {
						templateUrl: 'supply-chain/favorites.html'
					}
				}
			})
			.state('app.supply-chain.create-report', {
				url: '/create-report',
				views: {
					'main@': {
						templateUrl: 'supply-chain/reports/create-report.html'
					}
				}
			})
			.state('app.supply-chain.inventory-burnoff', {
				url: '/inventory-burnoff/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/inventory-burnoff/inventory-burnoff.html',
						controller: 'inventoryBurnoff as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Inventory Burnoff',
					viewType: 'burnoff',
					timingName: 'Inventory Burnoff',
					doTiming: true
				}
			})
			.state('app.supply-chain.redirects.opportunities', {
				abstract: true,
				url: '/opp'
			})
			.state('app.supply-chain.opportunities', {
				abstract: true,
				url: '/opp'
			})
			.state('app.supply-chain.redirects.opportunities.savings', {
				url: '/savings',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.inventory-opportunities/pfep-all-items', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.inventory-opportunities/target-savings', {
				url: '/inventory-opportunities/target-savings/:reportId',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.inventory-opportunities/pfep-all-items', $location.search());
						},
						controllerAs: 'redirect'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.item-master-data-report', {
				url: '/item-master-data-report/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.inventory-opportunities/pfep-all-items', {
				url: '/inventory-opportunities/pfep-all-items/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.supplier-on-hand-inventory', {
				url: '/supplier-on-hand-inventory/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.inventory-opportunities/pfep-order-policy-optimization', {
				url: '/inventory-opportunities/pfep-order-policy-optimization/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.inventory-opportunities/pfep-min-max-resizing', {
				url: '/inventory-opportunities/pfep-min-max-resizing/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.inventory-opportunities/pfep-mrp-resizing', {
				url: '/inventory-opportunities/pfep-mrp-resizing/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA PFEP: MRP resizing',
					viewType: 'opportunities',
					timingName: 'Opportunities by MRP Resizing'
				}
			})
			.state('app.supply-chain.redirects.opportunities.over-max', {
				url: '/over-max',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.inventory-level-over-minmax-max', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.redirects.inventory-opportunities/inventory-level-over-minmax-max', {
				url: '/inventory-opportunities/inventory-level-over-minmax-max/:reportId',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							var params = $location.search();
							params.reportId = $state.reportId;
							$state.go('app.supply-chain.inventory-level-over-minmax-max', params);
						},
						controllerAs: 'redirect'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.inventory-level-over-minmax-max', {
				url: '/inventory-level-over-minmax-max/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'oppOverMax as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Inventory Opportunities By Over Max',
					viewType: 'opportunities',
					timingName: 'Opportunities by Over Max'
				}
			})
			.state('app.supply-chain.redirects.opportunities.weekly-change', {
				url: '/weekly-change',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.inventory-opportunities/weekly-inventory-change', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.inventory-opportunities/weekly-inventory-change', {
				url: '/inventory-opportunities/weekly-inventory-change/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.redirects.opportunities.excess-on-order', {
				url: '/excess-on-order',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.inventory-opportunities/purchase-orders-to-cancel', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.inventory-opportunities/purchase-orders-to-cancel', {
				url: '/inventory-opportunities/purchase-orders-to-cancel/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.redirects.opportunities.excess-on-hand', {
				url: '/excess-on-hand',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.inventory-opportunities/excess-and-obsolete-inventory', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.inventory-opportunities/excess-and-obsolete-inventory', {
				url: '/inventory-opportunities/excess-and-obsolete-inventory/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.redirects.opportunities.opp-post-cancel-next-90-days', {
				url: '/opp-post-cancel-next-90-days',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.inventory-opportunities/next-90-days', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.inventory-opportunities/next-90-days', {
				url: '/inventory-opportunities/next-90-days/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.inventory-opportunities/pfep-reorder-point-resizing', {
				url: '/inventory-opportunities/pfep-reorder-point-resizing/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.inventory-opportunities/pfep-safety-stock-optimization', {
				url: '/inventory-opportunities/pfep-safety-stock-optimization/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.redirects.opportunities.excess-on-order-over-lead-time', {
				url: '/excess-on-order-over-lead-time',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.pos-for-excess-over-lead-time-multiple', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.redirects.inventory-opportunities/pos-for-excess-over-lead-time-multiple', {
				url: '/inventory-opportunities/pos-for-excess-over-lead-time-multiple/:reportId',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							var params = $location.search();
							params.reportId = $state.reportId;
							$state.go('app.supply-chain.pos-for-excess-over-lead-time-multiple', params);
						},
						controllerAs: 'redirect'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.pos-for-excess-over-lead-time-multiple', {
				url: '/pos-for-excess-over-lead-time-multiple/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'oppExcessOnOrderOverLeadTimeMult as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Inventory Opportunities By Excess on Order Over Lead Time',
					viewType: 'opportunities',
					timingName: 'Opportunities by Excess on Order Over Lead Time'
				}
			})
			.state('app.supply-chain.redirects.opportunities.excess-on-hand-over-lead-time', {
				url: '/excess-on-hand-over-lead-time',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.excess-inventory-over-lead-time-multiple', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.redirects.inventory-opportunities/excess-inventory-over-lead-time-multiple', {
				url: '/inventory-opportunities/excess-inventory-over-lead-time-multiple/:reportId',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							var params = $location.search();
							params.reportId = $state.reportId;
							$state.go('app.supply-chain.excess-inventory-over-lead-time-multiple', params);
						},
						controllerAs: 'redirect'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.excess-inventory-over-lead-time-multiple', {
				url: '/excess-inventory-over-lead-time-multiple/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'oppExcessInventoryOverLeadTimeMultiple as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Inventory Opportunities By Excess on Hand Over Lead Time',
					viewType: 'opportunities',
					timingName: 'Opportunities by Excess on Hand Over Lead Time'
				}
			})
			.state('app.supply-chain.redirects.opportunities.rop-items-over-max', {
				url: '/rop-items-over-max',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.reorder-point-items-over-max', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.redirects.inventory-opportunities/reorder-point-items-over-max', {
				url: '/inventory-opportunities/reorder-point-items-over-max/:reportId',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							var params = $location.search();
							params.reportId = $state.reportId;
							$state.go('app.supply-chain.reorder-point-items-over-max', params);
						},
						controllerAs: 'redirect'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.reorder-point-items-over-max', {
				url: '/reorder-point-items-over-max/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'oppROPItemsOverMax as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Opportunities by ROP Items Over Max',
					viewType: 'opportunities',
					timingName: 'Opportunities by ROP Items Over Max'
				}
			})
			.state('app.supply-chain.redirects.manufactured-opportunities', {
				url: '/manufactured-opportunities',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.pfep-all-finished-goods', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.redirects.finished-goods-target-savings', {
				url: '/finished-goods-target-savings/:reportId',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							var params = $location.search();
							params.reportId = $state.reportId;
							$state.go('app.supply-chain.pfep-all-finished-goods', params);
						},
						controllerAs: 'redirect'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.pfep-all-finished-goods', {
				url: '/pfep-all-finished-goods/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'finishedGoodsOpportunityBySavings as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Finished Goods Target Savings',
					viewType: 'opportunities',
					timingName: 'Finished Goods Target Savings'
				}
			})
			.state('app.supply-chain.material-shortages', {
				abstract: true,
				url: '/shrt'
			})
			.state('app.supply-chain.redirects.material-shortages', {
				abstract: true,
				url: '/shrt'
			})
			.state('app.supply-chain.redirects.material-shortages.item', {
				url: '/item',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.material-shortages/shortages-by-item', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.material-shortages/shortages-by-item', {
				url: '/material-shortages/shortages-by-item/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.material-shortages/shortages-by-item-2', {
				url: '/material-shortages/shortages-by-item-2/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.material-shortages/shortages-by-item-3', {
				url: '/material-shortages/shortages-by-item-3/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.material-shortages/demand-simulation', {
				url: '/material-shortages/demand-simulation/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'demandSimulation as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Demand Scenario Modeling',
					viewType: 'shortages',
					timingName: 'Demand scenario modeling'
				}
			})
			.state('app.supply-chain.redirects.material-shortages.order-new', {
				url: '/order-new',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.material-shortages/shortages-by-order', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.material-shortages/shortages-by-order', {
				url: '/material-shortages/shortages-by-order/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.redirects.material-shortages.minmaxundermin', {
				url: '/minmaxundermin',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.material-shortages/minmax-items-under-min', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.material-shortages/minmax-items-under-min', {
				url: '/material-shortages/minmax-items-under-min/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.redirects.material-shortages.items-under-safety-stock', {
				url: '/items-under-safety-stock',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.material-shortages/items-under-safety-stock', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.material-shortages/items-under-safety-stock', {
				url: '/material-shortages/items-under-safety-stock/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.purchase-reqs', { // This is obsolete URL. This will be redirected to app.supply-chain.supply-purchase-requisitions
				url: '/purchase-reqs-inside-lead-time',
				views: {
					'main@': {
						controller: 'prInsideLeadTime as tableCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Purchase Requisitions',
					viewType: 'purchase-reqs',
					timingName: 'Purchase Requisitions',
					doTiming: true
				}
			})
			.state('app.supply-chain.redirects.tasks', {
				url: '/tasks',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.procurement-tasks', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.procurement-tasks', {
				url: '/procurement-tasks/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.line-of-balance/all-parts', {
				url: '/line-of-balance/all-parts/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: { squash: true, value: null }
				}
			})
			.state('app.supply-chain.line-of-balance/all-parts-2', {
				url: '/line-of-balance/all-parts-2/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: { squash: true, value: null }
				}
			})
			.state('app.supply-chain.line-of-balance/all-parts-3', {
				url: '/line-of-balance/all-parts-3/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: { squash: true, value: null }
				}
			})
			.state('app.supply-chain.line-of-balance/end-item', {
				url: '/line-of-balance/end-item/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: { squash: true, value: null }
				}
			})
			.state('app.supply-chain.performance', {
				url: '/perf'
			})
			.state('app.supply-chain.redirects.performance', {
				abstract: true,
				url: '/perf'
			})
			.state('app.supply-chain.redirects.performance.supplier', {
				url: '/supplier',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.performance-summary/last-month-performance', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.performance-summary/last-month-performance', {
				url: '/performance-summary/last-month-performance/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'supplierPerformanceSummary as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Supplier Performance Last Month',
					viewType: 'supplierperf',
					timingName: 'Supplier Performance Last Month'
				}
			})
			.state('app.supply-chain.redirects.performance.rolling', {
				url: '/rolling',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.performance-summary/rolling-average-performance', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.performance-summary/rolling-average-performance', {
				url: '/performance-summary/rolling-average-performance/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'supplierPerformanceSummary as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Supplier Performance Rolling Average',
					viewType: 'supplierperf',
					timingName: 'Supplier Performance Rolling Average'
				}
			})
			.state('app.supply-chain.performance.buckets', {
				url: '/delivery-performance-12months',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'supplierPerformanceSummary as tableCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Supplier Performance Rolling Average',
					viewType: 'supplierperf',
					timingName: 'Supplier Performance Rolling Average'
				}
			})
			.state('app.supply-chain.scorecard', {
				url: '/supplier',
				views: {
					'main@': {
						controller: 'scorecardCtrl as tableCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Supplier Scorecard',
					viewType: 'scorecard',
					timingName: 'Supplier Scorecard'
				}
			})
			.state('app.supply-chain.redirects.supplier-projects', {
				url: '/supplier-projects',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.supplier-projects', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.supplier-projects', {
				url: '/supplier-projects/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'viewProjects as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Supplier Projects',
					viewType: 'supplierProjects',
					timingName: 'Supplier Projects'
				}
			})
			.state('app.supply-chain.edit-project', {
				url: '/edit-project?projectNdx',
				views: {
					'main@': {
						templateUrl: 'lean-projects/projects/edit-project.html',
						controller: 'editProject as editProjectController'
					}
				},
				data: {
					pageTitle: 'LeanDNA Edit Project',
					timingName: 'Edit Project',
					doTiming: true
				}
			})
			.state('app.supply-chain.spend-summary', {
				abstract: true,
				url: '/spend'
			})
			.state('app.supply-chain.redirects.spend-summary', {
				abstract: true,
				url: '/spend'
			})
			.state('app.supply-chain.redirects.spend-summary.supplier', {
				url: '/supplier',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.spend-summary/supplier-spend', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.spend-summary/supplier-spend', {
				url: '/spend-summary/supplier-spend/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'spendSummary as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Spend Summary (Supplier)',
					viewType: 'spendsummary',
					timingName: 'Spend Summary by Supplier'
				}
			})
			.state('app.supply-chain.redirects.spend-summary.material-group', {
				url: '/material-group',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.spend-summary/material-group-spend', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.spend-summary/material-group-spend', {
				url: '/spend-summary/material-group-spend/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'spendSummary as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Spend Summary (Material Group)',
					viewType: 'spendsummary',
					timingName: 'Spend Summary by Material Group'
				}
			})
			.state('app.supply-chain.redirects.spend-summary.item-group', {
				url: '/item-group',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.spend-summary/item-group-spend', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.spend-summary/item-group-spend', {
				url: '/spend-summary/item-group-spend/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'spendSummary as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Spend Summary (Item Group)',
					viewType: 'spendsummary',
					timingName: 'Spend Summary by Item Group'
				}
			})
			.state('app.supply-chain.spend-analytics', {
				abstract: true,
				url: '/spend-analytics'
			})
			.state('app.supply-chain.redirects.spend-analytics', {
				abstract: true,
				url: '/spend-analytics'
			})
			.state('app.supply-chain.redirects.spend-analytics.supplier', {
				url: '/supplier',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.spend-analytics/supplier-spend', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.spend-analytics/supplier-spend', {
				url: '/spend-analytics/supplier-spend/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'analyticsSpend as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Spend Analytics By Supplier',
					viewType: 'spendanalytics',
					timingName: 'Spend Analytics by Supplier'
				}
			})
			.state('app.supply-chain.redirects.spend-analytics.item', {
				url: '/item',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.spend-analytics/item-spend', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.spend-analytics/item-spend', {
				url: '/spend-analytics/item-spend/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'analyticsSpend as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Spend Analytics By Item',
					viewType: 'spendanalytics',
					timingName: 'Spend Analytics by Item'
				}
			})
			.state('app.supply-chain.cross-site', {
				abstract: true,
				url: '/cross-site'
			})
			.state('app.supply-chain.redirects.cross-site', {
				abstract: true,
				url: '/cross-site'
			})
			.state('app.supply-chain.cross-site.redirect.item-master', {
				url: '/item-master',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.item-master-data', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.cross-site.item-master', {
				url: '/item-master',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.item-master-data', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.item-master-data', {
				url: '/item-master-data/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/cross-site/item-master.html',
						controller: 'crossSiteItemMaster as itemMasterCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Cross Site Item Master',
					timingName: 'Cross Site Item Master'
				}
			})
			.state('app.supply-chain.redirects.cross-site.excess-to-sell', {
				url: '/excess-to-sell',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.excess-to-sell', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.excess-to-sell', {
				url: '/excess-to-sell/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'excessToSell as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Excess To Sell',
					timingName: 'Excess to Sell'
				}
			})
			.state('app.supply-chain.redirects.cross-site.excess-to-transfer', {
				url: '/excess-to-transfer',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.excess-to-transfer', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.excess-to-transfer', {
				url: '/excess-to-transfer/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Excess to Transfer',
					timingName: 'Excess to Transfer'
				}
			})
			.state('app.supply-chain.redirects.purchase-order-compliance', {
				url: '/purchase-order-compliance',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.purchase-order-compliance', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.purchase-order-compliance', {
				url: '/purchase-order-compliance/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'purchaseOrderCompliance as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Purchase Order Compliance',
					timingName: 'Purchase Order Compliance'
				}
			})
			.state('app.supply-chain.redirects.order-policies', {
				url: '/order-policies',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.order-policies', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.order-policies', {
				url: '/order-policies/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'orderPolicies as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Procurement Order Policies',
					timingName: 'Procurement Order Policies'
				}
			})
			.state('app.supply-chain.procurement-history', {
				url: '/procurement-history',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'procurementAnalysisHistory as tableCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Procurement Analysis History',
					viewType: 'procurementhistory',
					timingName: 'Procurement History'
				}
			})
			.state('app.supply-chain.item-search', {
				url: '/item-search?search&sites',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'globalItemSearchResults as tableCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Item Search',
					viewType: 'itemsearch',
					timingName: 'Item Search'
				}
			})
			.state('app.supply-chain.redirects.requirements-raw', {
				url: '/requirements-raw',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.requirements/raw-requirements', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.requirements/raw-requirements', {
				url: '/requirements/raw-requirements/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.redirects.requirements-bucket', {
				url: '/requirements-bucket',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.requirements/weekly-requirements', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.requirements/weekly-requirements', {
				url: '/requirements/weekly-requirements/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.redirects.inventory-purchased', {
				url: '/inventory-purchased',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.inventory/purchased-inventory', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.inventory/purchased-inventory', {
				url: '/inventory/purchased-inventory/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.redirects.inventory-manufactured', {
				url: '/inventory-manufactured',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.inventory/manufactured-inventory', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.inventory/manufactured-inventory', {
				url: '/inventory/manufactured-inventory/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.redirects.supply-all', {
				url: '/supply',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.supply-orders', $location.search());
						},
						controllerAs: 'redirect'

					}
				}
			})
			.state('app.supply-chain.supply-orders', {
				url: '/supply-orders/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.redirects.supply-purchase-orders', {
				url: '/supply/purchase-orders',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.purchase-orders', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.purchase-orders', {
				url: '/purchase-orders/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.purchase-order-changes', {
				url: '/purchase-order-changes/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.customer-order-changes', {
				url: '/customer-order-changes/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.open-customer-orders', {
				url: '/open-customer-orders/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'openCustomerOrders as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Open Customer Orders',
					viewType: 'opencustomerorders',
					timingName: 'Open Customer Orders'
				}
			})
			.state('app.supply-chain.redirects.supply-purchase-requisitions', {
				url: '/supply/purchase-requisitions?orderNumber&drilldown&factory',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.purchase-requisitions', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.purchase-requisitions', {
				url: '/purchase-requisitions/:reportId?supplyOrderNumber&factory&drilldown',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: { squash: true, value: null },
					supplyOrderNumber: { squash: true, value: null },
					factory: { squash: true, value: null },
					drilldown: { squash: true, value: null }
				}
			})
			.state('app.supply-chain.clear-to-build/single-level', {
				url: '/clear-to-build/single-level/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: { squash: true, value: null }
				}
			})
			.state('app.supply-chain.clear-to-build/multi-level', {
				url: '/clear-to-build/multi-level/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: { squash: true, value: null }
				}
			})
			.state('app.my-work.redirects', {
				abstract: true
			})
			.state('app.my-work.redirects.buyer-workbench', {
				url: '/buyer-workbench',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.my-work.buyer-workbench/all', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.my-work.buyer-workbench/by-supplier', {
				url: '/buyer-workbench/by-supplier/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'buyerWorkbench as tableCtrl'
					}
				},
				params: {
					reportId: { squash: true, value: null }
				},
				data: {
					pageTitle: 'LeanDNA Workbench',
					viewType: 'buyerWorkbench',
					timingName: 'Workbench'
				}
			})
			.state('app.my-work.buyer-workbench/all', {
				url: '/buyer-workbench/all/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'buyerWorkbench as tableCtrl'
					}
				},
				params: {
					reportId: { squash: true, value: null }
				},
				data: {
					pageTitle: 'LeanDNA Workbench',
					viewType: 'buyerWorkbench',
					timingName: 'Workbench'
				}
			})
			.state('app.my-work.redirects.summary-workbench', {
				url: '/summary-workbench',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.my-work.summary-workbench', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.my-work.summary-workbench', {
				url: '/summary-workbench/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: { squash: true, value: null }
				}
			})
			.state('app.my-work.summary-workbench/buyer/by-buyer', {
				url: '/summary-workbench/buyer/by-buyer/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: { squash: true, value: null }
				}
			})
			.state('app.my-work.summary-workbench/buyer/all', {
				url: '/summary-workbench/buyer/all/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: { squash: true, value: null }
				}
			})
			.state('app.my-work.summary-workbench/supplier/by-supplier', {
				url: '/summary-workbench/supplier/by-supplier/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: { squash: true, value: null }
				}
			})
			.state('app.my-work.summary-workbench/supplier/all', {
				url: '/summary-workbench/supplier/all/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: { squash: true, value: null }
				}
			})
			.state('app.my-work.summary-workbench/supervisor/all', {
				url: '/summary-workbench/supervisor/all/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: { squash: true, value: null }
				}
			})
			.state('app.supply-chain.redirects.production-orders', {
				url: '/supply/production-orders',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.production-orders', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.production-orders', {
				url: '/production-orders/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.redirects.planned-production-orders', {
				url: '/supply/production-orders?orderNumber&drilldown&factory',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.planned-production-orders', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.planned-production-orders', {
				url: '/planned-production-orders/:reportId?supplyOrderNumber&factory&drilldown',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null},
					supplyOrderNumber: {squash: true, value: null},
					drilldown: {squash: true, value: null},
					factory: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.purchase-requisitions-history', {
				url: '/purchase-requisitions-history/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'purchaseRequisitionsHistory as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Purchase Requisitions History',
					viewType: 'purchaseorders',
					timingName: 'Purchase Requisitions'
				}
			})
			.state('app.supply-chain.redirects.indirect-purchase-orders', {
				url: '/indirect-purchase-orders',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.indirect-purchase-orders', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.indirect-purchase-orders', {
				url: '/indirect-purchase-orders/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'indirectPurchaseOrder as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Indirect Purchase Orders',
					viewType: 'indirectpurchaseorders',
					timingName: 'Indirect Purchase Orders'
				}
			})
			.state('app.supply-chain.purchase-order-receipts', {
				url: '/purchase-order-receipts/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.redirects.orders', {
				url: '/order',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.orders', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.orders', {
				url: '/orders/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'orders as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Orders',
					viewType: 'orders',
					timingName: 'Orders'
				}
			})
			.state('app.supply-chain.past-requirements', {
				url: '/past-requirements/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: { squash: true, value: null }
				}
			})
			.state('app.supply-chain.purchase-order-confirmations', {
				url: '/purchase-order-confirmations/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				},
				params: {
					reportId: { squash: true, value: null }
				}
			})
			.state('app.supply-chain.supplier-quality', {
				url: '/supplier-quality/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'supplierQuality as tableCtrl'
					}
				},
				params: {
					reportId: { squash: true, value: null }
				},
				data: {
					pageTitle: 'LeanDNA Supplier Quality',
					viewType: 'supplierquality',
					timingName: 'Supplier Quality'
				}
			})
			.state('app.supply-chain.pos-to-action-report', {
				url: '/pos-to-action-report',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'poToAction12Month as tableCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Inventory Opportunities By POs To Action Next 12 Months',
					viewType: 'potoaction12months',
					timingName: 'Opportunities by POs to Action Next 12 Months'
				},
				params: {
					month: null,
					startDate: null,
					filters: null
				}
			})
			.state('app.supply-chain.redirects.inventory-action-report', {
				url: '/inventory-action-report',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.inventory-actions', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.inventory-actions', {
				url: '/inventory-actions/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'inventoryActionCustomerReport as tableCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Inventory Actions',
					viewType: 'inventory-action-report',
					timingName: 'Inventory Actions'
				},
				params: {
					weekStartTimestamp: null,
					weekEndTimestamp: null,
					reportingPeriods: null,
					filters: null,
					reportId: {squash: true, value: null}
				}
			})
			.state('app.supply-chain.procurement', {
				abstract: true,
				url: '/procurement'
			})
			.state('app.supply-chain.redirects.procurement', {
				abstract: true,
				url: '/procurement'
			})
			.state('app.supply-chain.redirects.procurement.pq-by-cost', {
				url: '/pq-by-cost',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.pq-analysis/pq-by-cost', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.pq-analysis/pq-by-cost', {
				url: '/pq-analysis/pq-by-cost/:reportId',
				views: {
					'main@': {
						templateUrl: 'reports/pq-by-cost.html',
						controller: 'pqByCostCtrl as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA PQ Analysis By Cost',
					viewType: 'procurementAnalysis',
					timingName: 'PQ Analysis by Cost'
				}
			})
			.state('app.supply-chain.redirects.procurement.abc-analysis', {
				url: '/abc-analysis',
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.pq-analysis/abc-analysis', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.redirect.pq-analysis/abc-analysis', {
				url: '/pq-analysis/abc-analysis/',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.supply-chain.pq-analysis/abc-analysis', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.supply-chain.pq-analysis/abc-analysis', {
				url: '/pq-analysis/abc-analysis/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'procurementAbcAnalysis as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Purchased Inventory by Recommended ABC Classification',
					viewType: 'procurementAnalysis',
					timingName: 'Purchased Inventory by Recommended ABC Classification'
				}
			})
			.state('app.supply-chain.analysis', {
				url: '/analysis',
				views: {
					'main@': {
						templateUrl: 'core/item-drilldown/price-break-analysis.html',
						controller: 'priceBreakAnalysis as priceBreakAnalysisCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Price Break Analysis',
					timingName: 'Price Break Analysis'
				}
			})

			.state('app.supply-chain.workbench', {
				url: '/workbench/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'workbench as tableCtrl'
					}
				},
				params: {
					reportId: { squash: true, value: null }
				},
				data: {
					pageTitle: 'LeanDNA Workbench',
					viewType: 'workbench',
					timingName: 'Workbench'
				}
			})
			// **************  SUPPLY CHAIN END 	************** //
			// **************  LEAN PROJECTS START 	************** //
			.state('app.lean-projects', {
				abstract: true,
				url: 'lean-projects'
			})
			.state('app.lean-projects.redirects', {
				abstract: true
			})
			.state('app.my-work.metric-enter', {
				url: '/metric-enter',
				views: {
					'main@': {
						templateUrl: 'lean-projects/metric/enter-data.html',
						controller: 'enterData as tableCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Enter Metric Data',
					timingName: 'Enter Metric Data',
					doTiming: false
				}
			})
			.state('app.lean-projects.metric-view', {
				url: '/metric-view/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'viewMetricData as tableCtrl'
					}
				},
				params: {
					reportId: { squash: true, value: null }
				},
				data: {
					pageTitle: 'LeanDNA View Metric Data',
					timingName: 'View metric data'
				}
			})
			.state('app.lean-projects.report-card', {
				url: '/report-card/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'valueStreamReportCard as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Value Streams',
					viewType: 'reportcard',
					timingName: 'Value Streams'
				}
			})
			.state('app.lean-projects.redirects.kanban-board', {
				url: '/kanban-board',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.lean-projects.projects-kanban', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.lean-projects.projects-kanban', {
				url: '/projects-kanban/:reportId',
				views: {
					'main@': {
						templateUrl: 'lean-projects/projects/kanban-board.html',
						controller: 'kanbanBoard as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA View Projects Kanban',
					timingName: 'Kanban Board',
					doTiming: true
				}
			})
			.state('app.lean-projects.redirects.view-projects', {
				url: '/view-projects', // we still need this because of the trailing slash
				views: {
					'main@': {
						resolvePolicy: {when: 'EAGER'},
						controller: function($state, $location) {
							$state.go('app.lean-projects.view-projects', $location.search());
						},
						controllerAs: 'redirect'
					}
				},
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				}
			})
			.state('app.lean-projects.view-projects', {
				url: '/view-projects/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'viewProjects as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA View Projects',
					viewType: 'viewProjects',
					timingName: 'View Projects',
					doTiming: true
				}
			})
			.state('app.lean-projects.redirects.view-tasks', {
				url: '/view-tasks',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.lean-projects.view-tasks', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.lean-projects.view-tasks', {
				url: '/view-tasks/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'viewTasks as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA View Tasks',
					viewType: 'viewTasks',
					timingName: 'View Tasks'
				}
			})
			.state('app.lean-projects.redirects.approve-projects', {
				url: '/approve-projects',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.lean-projects.approve-projects', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.lean-projects.approve-projects', {
				url: '/approve-projects/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'viewProjects as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Approve Projects',
					viewType: 'approveProjects',
					timingName: 'Approve Projects'
				}
			})
			.state('app.lean-projects.project-search', {
				url: '/project-search?drilldown=1&search',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'viewProjects as tableCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Project Search',
					viewType: 'projectSearch',
					timingName: 'Project Search'
				}
			})
			.state('app.lean-projects.edit-project', {
				url: '/edit-project?projectNdx',
				views: {
					'main@': {
						templateUrl: 'lean-projects/projects/edit-project.html',
						controller: 'editProject as editProjectController'
					}
				},
				data: {
					pageTitle: 'LeanDNA Edit Project',
					timingName: 'Edit Project',
					doTiming: true
				}
			})
			.state('app.lean-projects.redirects.individual-performance', {
				url: '/individual-performance',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.lean-projects.individual-performance', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.lean-projects.individual-performance', {
				url: '/individual-performance/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'individualPerformance as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Individual Performance',
					viewType: 'individualPerformance',
					timingName: 'Individual Performance'
				}
			})
			.state('app.lean-projects.redirects.goal-performance', {
				url: '/goal-performance',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'goalPerformance as tableCtrl'
					}
				}
			})
			.state('app.lean-projects.goal-performance', {
				url: '/goal-performance/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'goalPerformance as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Goal Performance',
					viewType: 'goalPerformance',
					timingName: 'Goal Performance'
				}
			})
			.state('app.lean-projects.redirects.gantt-chart', {
				url: '/gantt-chart',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.lean-projects.projects-gantt', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.lean-projects.projects-gantt', {
				url: '/projects-gantt/:reportId',
				views: {
					'main@': {
						templateUrl: 'lean-projects/reports/gantt-chart.html',
						controller: 'ganttChart as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Gantt Chart',
					viewType: 'ganttChart',
					timingName: 'Gantt Chart'
				}
			})
			.state('app.lean-projects.x-matrix', {
				url: '/x-matrix',
				views: {
					'main@': {
						templateUrl: 'lean-projects/x-matrix/x-matrix.html',
						controller: 'xMatrix as xm'
					}
				},
				data: {
					pageTitle: 'LeanDNA X-Matrix',
					timingName: 'Dashboard',
					doTiming: true
				}
			})
			.state('app.lean-projects.redirect.assessment-scoring', {
				url: '/assessment/scoring',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.lean-projects.assessment-scoring', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
			.state('app.lean-projects.assessment-scoring', {
				url: '/assessment-scoring/:reportId',
				views: {
					'main@': {
						templateUrl: 'lean-projects/assessments/scoring.html',
						controller: 'scoring as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Assessment Scoring',
					timingName: 'Assessment Scoring'
				}
			})
			.state('app.lean-projects.view-assessments', {
				url: '/view-assessments/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'viewAssessments as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA View Assessments',
					timingName: 'View Assessments'
				}
			})
			.state('app.lean-projects.assessments-summary', {
				url: '/assessments-summary/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'assessmentsSummary as tableCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Assessments Summary',
					timingName: 'Assessments Summary'
				}
			})
			.state('app.my-work.update-targets', {
				url: '/update-targets',
				views: {
					'main@': {
						templateUrl: 'setup/metricsAndGoals/updateTargets/templates/update-targets.html',
						controller: 'updateTargets as tableCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Update Targets',
					viewType: 'updatetargets',
					timingName: 'Update Targets'
				}
			})
			.state('app.my-work.update-weekly-targets', {
				url: '/update-weekly-targets',
				views: {
					'main@': {
						templateUrl: 'setup/metricsAndGoals/updateTargets/templates/update-targets.html',
						controller: 'updateWeeklyTargets as tableCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Update Weekly Targets',
					viewType: 'updatetargets',
					timingName: 'Update Targets'
				}
			})
			// **************  LEAN PROJECTS END 	************** //
			// **************  ACCOUNT START ************** //
			.state('app.account', {
				url: 'account',
				abstract: true
			})
			.state('app.account.edit', {
				url: '/edit',
				views: {
					'main@': userDetailsView()
				},
				data: {
					pageTitle: 'LeanDNA My Account',
					timingName: 'My Account'
				}
			})
			.state('app.account.change-password', {
				url: '/change-password',
				views: {
					'main@': {
						templateUrl: 'setup/change_password.html',
						controller: 'changePasswordCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Change My Password',
					timingName: 'Change Password'
				}
			})
			// **************  SETUP START ************** //
			.state('app.setup', {
				url: 'setup',
				abstract: true
			})
			.state('app.company-setup', {
				url: 'company-setup',
				abstract: true
			})
			.state('app.site-setup', {
				url: 'site-setup',
				abstract: true,
				views: {
					'left@': {
						controller: 'setupNavigation'
					}
				}
			})
			.state('app.leandna-setup', {
				url: 'leandna-setup',
				abstract: true
			})
			.state('app.site-setup.metrics-and-goals-setup', {
				url: '/metrics-and-goals-setup',
				views: {
					'main@': {
						templateUrl: 'setup/metricsAndGoals/general/metrics-and-goals-setup.html',
						controller: 'metricsGeneral as metricsGeneralCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Metrics and Goals Setup',
					timingName: 'Metrics and Goals Setup'
				}
			})
			.state('app.setup.updateTargets', {
				url: '/update-targets',
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.lean-projects.update-targets', $location.search());
						},
						controllerAs: 'redirect'
					}
				},
				data: {
					pageTitle: 'LeanDNA Update Targets',
					viewType: 'updatetargets',
					timingName: 'Update Targets'
				}
			})
			.state('app.setup.updateWeeklyTargets', {
				url: '/update-weekly-targets',
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.lean-projects.update-weekly-targets', $location.search());
						},
						controllerAs: 'redirect'
					}
				},
				data: {
					pageTitle: 'LeanDNA Update Weekly Targets',
					viewType: 'updatetargets',
					timingName: 'Update Targets'
				}
			})
			.state('app.leandna-setup.create-factory', {
				url: '/create-factory?:showAddNewCustomer',
				views: {
					'main@': {
						templateUrl: 'setup/create_factory.html',
						controller: 'createFactoryCtrl'
					}
				},
				params: {
					showAddNewCustomer: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Create Factory',
					timingName: 'Create Factory'
				}
			})
			.state('app.leandna-setup.clone-settings' , {
				url: '/clone-settings',
				views: {
					'main@': {
						templateUrl: 'setup/clone_settings.html',
						controller: 'cloneSettingsCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Clone Factory Settings',
					timingName: 'Clone Factory Settings'
				}
			})
			.state('app.leandna-setup.customer-success-report', {
				url: '/customer-success-report',
				views: {
					'main@': {
						templateUrl: 'setup/leandna/customer-success-report.html',
						controller: 'customerSuccessReport',
						controllerAs: 'tableCtrl'
					}
				}
			})
			.state('app.leandna-setup.manage-cache', {
				url: '/manage-cache',
				views: {
					'main@': {
						templateUrl: 'setup/cache/manage-cache.html',
						controller: 'manageCacheCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Manage Cache',
					timingName: 'Manage Cache'
				}
			})
			.state('app.leandna-setup.email-report', {
				url: '/email-report',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'emailReport as tableCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Data Email Report',
					timingName: 'Email Report'
				}
			})
			.state('app.leandna-setup.audit-log', {
				url: '/audit-log',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'auditLog as tableCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Audit Log Report',
					timingName: 'Audit Log'
				}
			})
			.state('app.company-setup.manage-users', {
				url: '/manage-users',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'manageUsers as tableCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Manage Users',
					timingName: 'Manage Users'
				}
			})
			.state('app.company-setup.config-sso', {
				url: '/config-sso',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'configSSO as tableCtrl'
					}
				},
				data: {
					pageTitle: 'SSO Setup',
					timingName: 'SSO config'
				}
			})
			.state('app.company-setup.workbench-customer-config', {
				url: '/workbench-customer-config',
				views: {
					'main@': {
						templateUrl: 'setup/customer/general/workbench-customer-config.html',
						controller: 'workbenchCustomerConfig'
					}
				},
				data: {
					pageTitle: 'Workbench Customer Config',
					timingName: 'Workbench Customer Config'
				}
			})
			.state('app.company-setup.cross-site-mapping-configuration', {
				url: '/cross-site-mapping-configuration',
				views: {
					'main@': {
						templateUrl: 'setup/customer/supply-chain/cross-site-mapping-configuration.html',
						controller: 'crossSiteMappingConfiguration',
						controllerAs: 'ctrl'
					}
				},
				data: {
					pageTitle: 'Cross-site mapping configuration',
					timingName: 'Cross-site mapping configuration'
				}
			})
			.state('app.company-setup.procurement-task-custom-fields', {
				url: '/procurement-task-custom-fields',
				views: {
					'main@': {
						templateUrl: 'setup/supplyChain/procurement/procurement-task-custom-fields.html'
					}
				},
				data: {
					pageTitle: 'Procurement Task Custom Fields',
					timingName: 'Procurement Task Custom Fields'
				}
			})
			.state('app.company-setup.dashboard-templates', {
				url: '/dashboard-templates',
				views: {
					'main@': {
						templateUrl: 'setup/customer/general/dashboard-templates.html',
						controller: 'dashboardTemplates'
					}
				}
			})
			.state('app.company-setup.report-templates', {
				url: '/report-templates',
				views: {
					'main@': {
						templateUrl: 'setup/customer/general/report-templates.html',
						controller: 'reportTemplates'
					}
				}
			})
			.state('app.company-setup.manage-email-alerts', {
				url: '/manage-email-alerts',
				views: {
					'main@': {
						templateUrl: 'setup/customer/notifications/manage-subscriptions.html',
						controller: 'manageSubscriptions'
					}
				},
				data: {
					pageTitle: 'LeanDNA Manage Email Alerts',
					timingName: 'Manage Email Alerts'
				}
			})
			.state('app.site-setup.email-settings', {
				url: '/email-settings',
				views: {
					'main@': {
						templateUrl: 'setup/users/email-settings.html',
						controller: 'emailSettings as emailSettingsCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Manage Email Settings',
					timingName: 'Manage Email Settings'
				}
			})
			.state('app.setup.newUser', {
				url: '/new-user',
				views: {
					'main@': {
						templateUrl: 'setup/new_user.html',
						controller: 'newUserCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA New User',
					timingName: 'New User'
				}
			})
			.state('app.setup.newSupplier', {
				url: '/new-supplier',
				views: {
					'main@': {
						templateUrl: 'setup/global/manageUsers/new-supplier.html',
						controller: 'newSupplier',
						controllerAs: 'newSupplierCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA New Supplier User',
					timingName: 'New Supplier User'
				}
			})
			.state('app.company-setup.userForm', {
				url: '/user-form?userNdx',
				views: {
					'main@': userDetailsView()
				},
				data: {
					pageTitle: 'LeanDNA Edit User',
					timingName: 'Edit User'
				}
			})
			.state('app.setup.data-pipeline', {
				url: '/data-pipeline',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'dataPipelineSummary as tableCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Data Pipeline Status',
					timingName: 'Data Pipeline'
				}
			})
			.state('app.setup.data-pipeline-leansync', {
				url: '/data-pipeline-leansync',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'dataPipelineSummary as tableCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Data Sync Status',
					timingName: 'Data Sync Status'
				}
			})
			.state('app.setup.data-pipeline-history', {
				url: '/data-pipeline-history?factoryNdx',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'dataPipelineHistory as tableCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Data Pipeline Site History',
					timingName: 'Data Pipeline Site History'
				}
			})
			.state('app.setup.data-pipeline-health-check', {
				url: '/data-pipeline-health-check?factoryNdx&jobId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reactReport as tableCtrl'
					}
				}
			})
			.state('app.setup.data-pipeline-health-check-history', {
				url: '/data-pipeline-health-check-history?factoryNdx',
				views: {
					'main@': {
						templateUrl: 'setup/data-pipeline-health-check-history.html',
						controller: 'dataPipelineHealthCheckHistory'
					}
				},
				data: {
					pageTitle: 'LeanDNA Data Pipeline Health Check History',
					timingName: 'Data Pipeline Site History'
				}
			})
			.state('app.setup.data-pipeline-health-check-trend', {
				url: '/data-pipeline-health-check-trend?factoryNdx',
				views: {
					'main@': {
						templateUrl: 'setup/data-pipeline-health-check-trend.html',
						controller: 'dataPipelineHealthCheckTrend'
					}
				},
				data: {
					pageTitle: 'LeanDNA Data Pipeline Health Check Trend',
					timingName: 'Data Pipeline Site Trend'
				}
			})
			.state('app.setup.data-pipeline-job-status', {
				url: '/data-pipeline-job-status',
				views: {
					'main@': {
						templateUrl: 'setup/data-pipeline-job-status.html',
						controller: 'dataPipelineJobStatus'
					}
				},
				data: {
					pageTitle: 'LeanDNA Data Pipeline Job Status',
					timingName: 'Data Pipeline Job Status'
				}
			})
			.state('app.site-setup.leansync-config', {
				url: '/leansync-config',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'leanSyncConfig as tableCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Lean Sync Configuration',
					timingName: 'Lean Sync Configuration'
				}
			})
			.state('app.site-setup.leansync-add-field', {
				url: '/leansync-add-field',
				views: {
					'main@': {
						templateUrl: 'setup/leansync/leansync-add-field.html',
						controller: 'leanSyncAddField as leanSyncAddFieldCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Lean Sync Add Field',
					timingName: 'Lean Sync Add Field'
				}
			})
			.state('app.site-setup.leansync-upload-file', {
				url: '/leansync-upload-file',
				views: {
					'main@': {
						templateUrl: 'setup/leansync/leansync-file-upload.html',
						controller: 'leanSyncFileUpload as leanSyncFileUploadCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Lean Sync File Upload',
					timingName: 'Lean Sync File Upload'
				}
			})
			.state('app.site-setup.expected-data-upload-schedule', {
				url: '/expected-data-upload-schedule',
				views: {
					'main@': {
						templateUrl: 'setup/supplyChain/expected-data-upload-schedule.html',
						controller: function () {}
					}
				},
				data: {
					pageTitle: 'Expected data upload schedule',
					timingName: 'Expected data upload schedule'
				}
			})
			.state('app.site-setup.configure-metric', {
				url: '/configure-metric?ndx',
				views: {
					'main@': {
						templateUrl: 'setup/metricsAndGoals/configureMetric/configure-metric.html',
						controller: 'configureMetric'
					}
				},
				data: {
					pageTitle: 'LeanDNA Configure Metric',
					timingName: 'Configure Metric'
				}
			})
			.state('app.site-setup.clone-metrics', {
				url: '/clone-metrics',
				views: {
					'main@': {
						templateUrl: 'setup/metricsAndGoals/cloneMetrics/clone-metrics.html',
						controller: 'cloneMetrics',
						controllerAs: 'cloneMetricsCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Clone Metrics',
					timingName: 'Clone Metrics'
				}
			})
			.state('app.site-setup.view-metrics', {
				url: '/view-metrics',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'viewMetrics as tableCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA View Metrics',
					timingName: 'View Metrics'
				}
			})
			.state('app.site-setup.strategic-goals', {
				url: '/strategic-goals',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'strategicGoals as tableCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Configure Goal',
					timingName: 'Configure Goals'
				}
			})
			.state('app.site-setup.supplier-performance', {
				url: '/supplier-performance',
				views: {
					'main@': {
						templateUrl: 'setup/supplier_performance.html',
						controller: 'configureSupplierPerformanceCtrl'
					}
				},
				date: {
					pageTitle: 'LeanDNA Configure Supplier Performance Settings',
					timingName: 'Configure Supplier Performance Settings'
				}
			})
			.state('app.site-setup.inventory-actions', {
				url: '/inventory-actions',
				views: {
					'main@': {
						templateUrl: 'setup/supplyChain/inventory-action-config.html',
						controller: 'inventoryActionConfig',
						controllerAs: 'actionConfigCtrl'
					}
				},
				date: {
					pageTitle: 'LeanDNA Configure Inventory Action Settings',
					timingName: 'Configure Inventory Action Settings'
				}
			})
			.state('app.company-setup.shortage-criticality-customer', {
				url: '/shortage-criticality-customer',
				views: {
					'main@': {
						templateUrl: 'setup/global/shortage-criticality-customer-config.html',
						controller: 'shortageCriticalityCustomerConfig',
						controllerAs: 'tableCtrl'
					}
				},
				date: {
					pageTitle: 'LeanDNA Configure Customer Shortage Criticality Level Settings',
					timingName: 'Configure Customer Shortage Criticality Level Settings'
				}
			})
			.state('app.company-setup.shortage-risk-score-customer', {
				url: '/shortage-risk-score-customer',
				views: {
					'main@': {
						templateUrl: 'setup/global/shortage-risk-score-customer-config.html',
						controller: 'shortageRiskScoreCustomerConfig',
						controllerAs: 'tableCtrl'
					}
				},
				date: {
					pageTitle: 'LeanDNA Configure Customer Shortage Risk Score Settings',
					timingName: 'Configure Customer Shortage Risk Score Settings'
				}
			})
			.state('app.leandna-setup.feature-flags', {
				url: '/feature-flags',
				views: {
					'main@': {
						templateUrl: 'setup/global/feature-flags.html',
						controller: 'featureFlagsConfig'
					}
				},
				date: {
					pageTitle: 'LeanDNA Feature Flags',
					timingName: 'Feature Flags'
				}
			})
			.state('app.company-setup.flex-field-config', {
				url: '/flex-field-config',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'flexFieldConfig as tableCtrl'
					}
				},
				date: {
					pageTitle: 'LeanDNA Configure Custom Supply Chain Field Settings',
					timingName: 'Configure Custom Supply Chain Field Settings'
				}
			})
			.state('app.company-setup.write-back-audit-log', {
				url: '/write-back-audit-log/:reportId',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'writeBackAuditLog as tableCtrl'
					}
				},
				params: {
					reportId: { squash: true, value: null }
				},
				resolve: {
					data: function ($q, $state, siteService) {
						if (!siteService.isWriteBackEnabled()){
							var deferred = $q.defer();
							$state.go('app.unauthorized', {});
							return deferred.promise;
						}
					}
				},
				date: {
					pageTitle: 'Write back audit log',
					timingName: 'Write back audit log'
				}
			})
			.state('app.company-setup.po-action-config', {
				url: '/po-action-config',
				views: {
					'main@': {
						templateUrl: 'setup/global/po-actions-customer-config.html',
						controller: 'poActionsCustomerConfig',
						controllerAs: 'tableCtrl'
					}
				}
			})
			.state('app.site-setup.shortage-criticality', {
				url: '/shortage-criticality',
				views: {
					'main@': {
						templateUrl: 'setup/supplyChain/shortage-criticality-config.html',
						controller: 'shortageCriticalityConfig',
						controllerAs: 'tableCtrl'
					}
				},
				date: {
					pageTitle: 'LeanDNA Configure Shortage Criticality Level Settings',
					timingName: 'Configure Shortage Criticality Level Settings'
				}
			})
			.state('app.site-setup.shortage-risk-score', {
				url: '/shortage-risk-score',
				views: {
					'main@': {
						templateUrl: 'setup/supplyChain/shortage-risk-score-config.html',
						controller: 'shortageRiskScoreConfig',
						controllerAs: 'tableCtrl'
					}
				},
				date: {
					pageTitle: 'LeanDNA Configure Shortage Risk Score Settings',
					timingName: 'Configure Shortage Risk Score Settings'
				}
			})
			.state('app.company-setup.unable-to-fix-categories', {
				url: '/unable-to-fix-categories',
				views: {
					'main@': {
						templateUrl: 'setup/supplyChain/unable-to-fix-categories.html',
						controller: 'inventoryActionConfig',
						controllerAs: 'actionConfigCtrl'
					}
				},
				date: {
					pageTitle: 'LeanDNA Unable to Fix Categories',
					timingName: 'Unable to Fix Categories'
				}
			})
			.state('app.site-setup.supply-chain-setup', {
				url: '/supply-chain-setup',
				views: {
					'main@': {
						templateUrl: 'setup/supplyChain/general/supply-chain-setup.html',
						controller: 'supplyChainGeneral',
						controllerAs: 'supplyChainGeneralCtrl'
					}
				},
				date: {
					pageTitle: 'LeanDNA Supply Chain Setup',
					timingName: 'Supply Chain Setup'
				}
			})
			.state('app.site-setup.analytics-engine', {
				url: '/analytics-engine',
				views: {
					'main@': {
						templateUrl: 'setup/supplyChain/procurement/procurement.html',
						controller: 'procurementSetup',
						controllerAs: 'procurementSetupCtrl'
					}
				},
				date: {
					pageTitle: 'LeanDNA Procurement Setup',
					timingName: 'Procurement Setup'
				}
			})
			.state('app.company-setup.project-general-customer-settings', {
				url: '/project-general-customer-settings',
				views: {
					'main@': {
						templateUrl: 'setup/global/projects/general/project-general-customer-settings.html',
						controller: 'projectGeneralCustomerSettings',
						controllerAs: 'projectGeneralCustomerCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Project General Customer Settings',
					timingName: 'Project General Customer Settings'
				}
			})
			.state('app.site-setup.project-general-settings', {
				url: '/project-general-settings',
				views: {
					'main@': {
						templateUrl: 'setup/projects/general/project-general-settings.html',
						controller: 'projectGeneralSettings',
						controllerAs: 'projectGeneralCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Project General Settings',
					timingName: 'Project General Settings'
				}
			})
			.state('app.site-setup.project-stages', {
				url: '/project-stages',
				views: {
					'main@': {
						templateUrl: 'setup/projects/stages/project-stages.html',
						controller: 'projectStages',
						controllerAs: 'projectStageCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Project Stages',
					timingName: 'Project Stages'
				}
			})
			.state('app.site-setup.project-areas', {
				url: '/project-areas',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'projectArea as tableCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Project Areas',
					viewType: 'areaapprovers',
					timingName: 'Project Areas'
				}
			})
			.state('app.site-setup.project-types', {
				url: '/project-types',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'projectType as tableCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Project Types',
					timingName: 'Project Types'
				}
			})
			.state('app.company-setup.project-saving-categories', {
				url: '/project-saving-categories',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'projectSavingCategory as tableCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Project Savings Categories',
					timingName: 'Project Savings Categories'
				}
			})
			.state('app.company-setup.project-custom-fields', {
				url: '/project-custom-fields',
				views: {
					'main@': {
						templateUrl: 'setup/projects/customFields/project-custom-fields.html',
						controller: 'projectCustomFields',
						controllerAs: 'customFieldsCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Project Custom Fields',
					timingName: 'Project Custom Fields'
				}
			})
			.state('app.site-setup.project-templates', {
				url: '/project-templates',
				views: {
					'main@': {
						templateUrl: 'setup/projects/templates/project-templates.html',
						controller: 'projectTemplates as tableCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Project Templates',
					viewType: 'areaapprovers',
					timingName: 'Project Templates'
				}
			})
			.state('app.setup.project-templates-tasks', {
				url: '/project-templates/tasks',
				views: {
					'main@': {
						templateUrl: 'setup/projects/templates/tasks/project-template-tasks.html',
						controller: 'projectTemplateTasks as projectTemplateTasksCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Project Template Tasks',
					viewType: 'areaapprovers',
					timingName: 'Project Template Tasks'
				}
			})
			.state('app.site-setup.import-projects', {
				url: '/import-projects',
				views: {
					'main@': {
						templateUrl: 'setup/projects/import/import-projects.html',
						controller: 'importProjects as tableCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Import Projects',
					timingName: 'Import Projects'
				}
			})
			.state('app.site-setup.clone-projects', {
				url: '/clone-projects',
				views: {
					'main@': {
						templateUrl: 'setup/projects/clone/clone-projects.html',
						controller: 'cloneProjects',
						controllerAs: 'cloneProjectsCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Clone Projects',
					timingName: 'Clone Projects'
				}
			})
			.state('app.site-setup.factory-general-settings', {
				url: '/factory-general-settings',
				views: {
					'main@': {
						templateUrl: 'setup/factory/general/factory-general-settings.html',
						controller: 'factoryGeneralSettings',
						controllerAs: 'factoryGeneralSettingsCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Factory General Settings',
					timingName: 'Factory General Settings'
				}
			})
			.state('app.site-setup.factory-order-policy-recommendations', {
				url: '/factory-order-policy-recommendations',
				views: {
					'main@': {
						templateUrl: 'setup/supplyChain/factory-order-policy-recommendations.html',
						controller: 'factoryOrderPolicyRecommendations',
						controllerAs: 'factoryOrderPolicyRecommendationsCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Order Policy Recommendations Settings',
					timingName: 'Order Policy Recommendations Settings'
				}
			})
			.state('app.site-setup.factory-line-of-balance', {
				url: '/factory-line-of-balance',
				views: {
					'main@': {
						templateUrl: 'setup/supplyChain/lob-configuration.html',
						controller: 'lobConfiguration'
					}
				},
				data: {
					pageTitle: 'LeanDNA Factory Line of Balance Settings',
					timingName: 'Line of Balance Settings'
				}
			})
			.state('app.site-setup.supplier-late-delivery-causes', {
				url: '/supplier-late-delivery-causes',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'supplierLateDeliveryIssues as tableCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Supplier Late Delivery Causes',
					timingName: 'Supplier Late Delivery Causes'
				}
			})
			.state('app.site-setup.workbench-configuration', {
				url: '/workbench-configuration',
				views: {
					'main@': {
						templateUrl: 'setup/supplyChain/workbench-configuration.html',
						controller: 'workbenchConfiguration'
					}
				},
				data: {
					pageTitle: 'Workbench Configuration',
					timingName: 'Workbench Configuration'
				}
			})
			.state('app.site-setup.write-back-config', {
				url: '/write-back-config',
				views: {
					'main@': {
						templateUrl: 'setup/supplyChain/write-back-config.html'
					}
				}
			})
			.state('app.site-setup.supplier-whitelist', {
				url: '/supplier-whitelist',
				views: {
					'main@': {
						templateUrl: 'setup/supplyChain/supplier-whitelist.html',
						controller: 'supplierWhitelist'
					}
				},
				data: {
					pageTitle: 'Supplier whitelist Settings',
					timingName: 'Supplier whitelist Settings'
				}
			})
			.state('app.company-setup.po-status-categories', {
				url: '/po-status-categories',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'poStatusCategories as tableCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA PO Status Categories',
					timingName: 'PO Status Categories'
				}
			})
			.state('app.company-setup.customer-order-status-categories', {
				url: '/customer-order-status-categories',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'customerOrderStatusCategories as tableCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Customer Order Status Categories',
					timingName: 'Customer Order Status Categories'
				}
			})
			.state('app.company-setup.supplier-portal-config', {
				url: '/supplier-portal-config',
				views: {
					'main@': {
						templateUrl: 'setup/global/supplier-portal-config.html',
						controller: 'supplierPortalConfig',
						controllerAs: 'supplierPortalConfigCtrl'
					}
				}
			})
			.state('app.company-setup.supplier-welcome-email-editor-customer', {
				url: '/supplier-welcome-email-editor-customer',
				views: {
					'main@': {
						templateUrl: 'setup/customer/general/supplier-welcome-email-editor.html',
						controller: 'supplierWelcomeEmailEditorCustomer as tableCtrl'
					}
				}
			})
			.state('app.site-setup.supplier-welcome-email-editor', {
				url: '/supplier-welcome-email-editor',
				views: {
					'main@': {
						templateUrl: 'setup/customer/general/supplier-welcome-email-editor.html',
						controller: 'supplierWelcomeEmailEditor as tableCtrl'
					}
				}
			})
			.state('app.setup.report-card-params', {
				url: '/report-card-params',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'reportCardParams as tableCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Report Card Parameters',
					timingName: 'Report Card Parameters'
				}
			})
			.state('app.site-setup.value-streams', {
				url: '/value-streams',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'valueStream as tableCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Setup Value Streams',
					timingName: 'Setup Value Streams'
				}
			})
			// **************  SETUP END ************** //
			.state('app.item-drilldown', {
				url: 'item-drilldown?itemCode',
				views: {
					'main@': {
						templateUrl: 'core/item-drilldown/item-drilldown.html',
						controller: 'itemDrilldownCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Item Details',
					timingName: 'Item Details'
				}
			})
			.state('app.my-assignments', {
				redirectTo: 'childState',
				url: 'my-assignments',
				data: {
					viewType: 'myAssignments'
				},
				resolve: {
					data: function ($q, $state, $experiments) {
						var deferred = $q.defer();
						$state.go('app.my-work.my-inventory-opportunities', {});
						return deferred.promise;
					}
				}
			})
			.state('app.unauthorized', {
				url: 'unauthorized',
				views: {
					'main@': {
						templateUrl: 'navigation/unauthorized.html'
					}
				},
				data: {
					pageTitle: 'LeanDNA Unauthorized',
					timingName: 'Unauthorized'
				}
			})
			.state('app.reports-export', {
				url: 'reports-export?&factoryNdx&reportId',
				views: {
					'main@': {
						templateUrl: 'reports/reports-export.html',
						controller: 'reportsExport as reportsExportCtrl'
					}
				},
				params: {
					reportId: {squash: true, value: null}
				},
				data: {
					pageTitle: 'LeanDNA Reports Export',
					timingName: 'Reports Export'
				}
			})
			.state('app.unauthorized-ip-address', {
				url: 'unauthorized-ip-address',
				views: {
					'main@': {
						templateUrl: 'navigation/unauthorized-ip-address.html'
					}
				},
				data: {
					pageTitle: 'LeanDNA Unauthorized',
					timingName: 'Unauthorized IP Address'
				}
			})
			.state('app.site-setup.project-categories', {
				url: '/project-categories',
				views: {
					'main@': {
						templateUrl: 'supply-chain/analytics/lean-grid.html',
						controller: 'projectCategories as tableCtrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Project Categories',
					viewType: 'areaapprovers',
					timingName: 'Categories'
				}
			})
			.state('app.typography', {
				url: 'typography',
				views: {
					'main@': {
						templateUrl: 'typography/typography.html'
					}
				},
				data: {
					pageTitle: 'LeanDNA Typography',
					timingName: 'typography'
				}
			})
			.state('app.company-setup.supply-chain-settings', {
				url: '/supply-chain-settings',
				views: {
					'main@': {
						templateUrl: 'setup/supplyChain/supply-chain-settings.html',
						controller: 'supplyChainSettings',
						controllerAs: 'ctrl'
					}
				},
				date: {
					pageTitle: 'LeanDNA Supply Chain Settings',
					timingName: 'Supply Chain Settings'
				}
			})
			.state('app.site-setup.buyer-mapping-configuration', {
				url: '/buyer-mapping-configuration',
				views: {
					'main@': {
						templateUrl: 'setup/factory/supply-chain/buyer-mapping-configuration.html',
						controller: 'buyerMappingConfiguration',
						controllerAs: 'ctrl'
					}
				},
				date: {
					pageTitle: 'LeanDNA Buyer Mapping Configuration',
					timingName: 'Buyer Mapping Configuration'
				}
			})
			.state('app.site-setup.indirect-spend-category-mapping', {
				url: '/indirect-spend-category-mapping',
				views: {
					'main@': {
						templateUrl: 'setup/factory/supply-chain/indirect-spend-category-mapping.html',
						controller: 'indirectSpendCategoryMapping',
						controllerAs: 'ctrl'
					}
				},
				data: {
					pageTitle: 'LeanDNA Indirect Spend Category Mapping',
					timingName: 'Indirect Spend Category Mapping'
				}
			})
			.state('app.setup.unsubscribe-email', {
				url: '/unsubscribe-email?customerNdx&emailType&byEmail',
				views: {
					'left@': {},
					'main@': {
						templateUrl: 'setup/unsubscribe-email.html'
					}
				},
				data: {
					pageTitle: 'LeanDNA Unsubscribe email',
					timingName: 'UnsubscribeEmail'
				}
			});

		// Old Navigation redirects
		$stateProvider
				.state('app.supply-chain.summary-workbench', {
					url: '/summary-workbench',
					resolve: {
						redirectParams: function($location, redirectParamsService) {
							redirectParamsService.putRedirectParams($location.search());
						}
					},
					views: {
						'main@': {
							controller: function($state, $location) {
								$state.go('app.my-work.summary-workbench', $location.search());
							},
							controllerAs: 'redirect'
						}
					}
				})
				.state('app.supply-chain.buyer-workbench/all', {
					url: '/buyer-workbench/all',
					resolve: {
						redirectParams: function($location, redirectParamsService) {
							redirectParamsService.putRedirectParams($location.search());
						}
					},
					views: {
						'main@': {
							controller: function($state, $location) {
								$state.go('app.my-work.buyer-workbench/all', $location.search());
							},
							controllerAs: 'redirect'
						}
					}
				})
				.state('app.supply-chain.buyer-workbench/by-supplier', {
					url: '/buyer-workbench/by-supplier',
					resolve: {
						redirectParams: function($location, redirectParamsService) {
							redirectParamsService.putRedirectParams($location.search());
						}
					},
					views: {
						'main@': {
							controller: function($state, $location) {
								$state.go('app.my-work.buyer-workbench/by-supplier', $location.search());
							},
							controllerAs: 'redirect'
						}
					}
				})
				.state('app.supply-chain.summary-workbench/buyer/by-buyer', {
					url: '/summary-workbench/buyer/by-buyer',
					resolve: {
						redirectParams: function($location, redirectParamsService) {
							redirectParamsService.putRedirectParams($location.search());
						}
					},
					views: {
						'main@': {
							controller: function($state, $location) {
								$state.go('app.my-work.summary-workbench/buyer/by-buyer', $location.search());
							},
							controllerAs: 'redirect'
						}
					}
				})
			.state('app.supply-chain.summary-workbench/buyer/all', {
				url: '/summary-workbench/buyer/all',
				resolve: {
					redirectParams: function($location, redirectParamsService) {
						redirectParamsService.putRedirectParams($location.search());
					}
				},
				views: {
					'main@': {
						controller: function($state, $location) {
							$state.go('app.my-work.summary-workbench/buyer/all', $location.search());
						},
						controllerAs: 'redirect'
					}
				}
			})
				.state('app.supply-chain.summary-workbench/supplier/by-supplier', {
					url: '/summary-workbench/supplier/by-supplier',
					resolve: {
						redirectParams: function($location, redirectParamsService) {
							redirectParamsService.putRedirectParams($location.search());
						}
					},
					views: {
						'main@': {
							controller: function($state, $location) {
								$state.go('app.my-work.summary-workbench/supplier/by-supplier', $location.search());
							},
							controllerAs: 'redirect'
						}
					}
				})
				.state('app.supply-chain.summary-workbench/supplier/all', {
					url: '/summary-workbench/supplier/all',
					resolve: {
						redirectParams: function($location, redirectParamsService) {
							redirectParamsService.putRedirectParams($location.search());
						}
					},
					views: {
						'main@': {
							controller: function($state, $location) {
								$state.go('app.my-work.summary-workbench/supplier/all', $location.search());
							},
							controllerAs: 'redirect'
						}
					}
				})
				.state('app.supply-chain.summary-workbench/supervisor/all', {
					url: '/summary-workbench/supervisor/all',
					resolve: {
						redirectParams: function($location, redirectParamsService) {
							redirectParamsService.putRedirectParams($location.search());
						}
					},
					views: {
						'main@': {
							controller: function($state, $location) {
								$state.go('app.my-work.summary-workbench/supervisor/all', $location.search());
							},
							controllerAs: 'redirect'
						}
					}
				})
				.state('app.lean-projects.metric-enter', {
					url: '/metric-enter',
					resolve: {
						redirectParams: function($location, redirectParamsService) {
							redirectParamsService.putRedirectParams($location.search());
						}
					},
					views: {
						'main@': {
							controller: function($state, $location) {
								$state.go('app.my-work.metric-enter', $location.search());
							},
							controllerAs: 'redirect'
						}
					}
				})
				.state('app.lean-projects.update-targets', {
					url: '/update-targets',
					resolve: {
						redirectParams: function($location, redirectParamsService) {
							redirectParamsService.putRedirectParams($location.search());
						}
					},
					views: {
						'main@': {
							controller: function($state, $location) {
								$state.go('app.my-work.update-targets', $location.search());
							},
							controllerAs: 'redirect'
						}
					}
				})
				.state('app.lean-projects.update-weekly-targets', {
					url: '/update-weekly-targets',
					resolve: {
						redirectParams: function($location, redirectParamsService) {
							redirectParamsService.putRedirectParams($location.search());
						}
					},
					views: {
						'main@': {
							controller: function($state, $location) {
								$state.go('app.my-work.update-weekly-targets', $location.search());
							},
							controllerAs: 'redirect'
						}
					}
				})
				.state('app.setup.manageUsers', {
					url: '/manage-users',
					resolve: {
						redirectParams: function($location, redirectParamsService) {
							redirectParamsService.putRedirectParams($location.search());
						}
					},
					views: {
						'main@': {
							controller: function($state, $location) {
								$state.go('app.company-setup.manage-users', $location.search());
							},
							controllerAs: 'redirect'
						}
					}
				})
				.state('app.setup.userForm', {
					url: '/user-form',
					resolve: {
						redirectParams: function($location, redirectParamsService) {
							redirectParamsService.putRedirectParams($location.search());
						}
					},
					views: {
						'main@': {
							controller: function($state, $location) {
								$state.go('app.company-setup.userForm', $location.search());
							},
							controllerAs: 'redirect'
						}
					}
				})
				.state('app.company-setup.data-pipeline', {
					url: '/data-pipeline',
					resolve: {
						redirectParams: function($location, redirectParamsService) {
							redirectParamsService.putRedirectParams($location.search());
						}
					},
					views: {
						'main@': {
							controller: function($state, $location) {
								$state.go('app.setup.data-pipeline', $location.search());
							},
							controllerAs: 'redirect'
						}
					}
				})
				.state('app.setup.configSSO', {
					url: '/config-sso',
					resolve: {
						redirectParams: function($location, redirectParamsService) {
							redirectParamsService.putRedirectParams($location.search());
						}
					},
					views: {
						'main@': {
							controller: function($state, $location) {
								$state.go('app.company-setup.config-sso', $location.search());
							},
							controllerAs: 'redirect'
						}
					}
				})
				.state('app.setup.supply-chain-settings', {
					url: '/supply-chain-settings',
					resolve: {
						redirectParams: function($location, redirectParamsService) {
							redirectParamsService.putRedirectParams($location.search());
						}
					},
					views: {
						'main@': {
							controller: function($state, $location) {
								$state.go('app.company-setup.supply-chain-settings', $location.search());
							},
							controllerAs: 'redirect'
						}
					}
				})
				.state('app.setup.buyer-mapping-configuration', {
        	url: '/buyer-mapping-configuration',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.site-setup.buyer-mapping-configuration', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
				})
				.state('app.setup.shortage-criticality-customer', {
					url: '/shortage-criticality-customer',
					resolve: {
						redirectParams: function($location, redirectParamsService) {
							redirectParamsService.putRedirectParams($location.search());
						}
					},
					views: {
						'main@': {
							controller: function($state, $location) {
								$state.go('app.company-setup.shortage-criticality-customer', $location.search());
							},
							controllerAs: 'redirect'
						}
					}
				})
        .state('app.setup.po-status-categories', {
        	url: '/po-status-categories',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.company-setup.po-status-categories', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.customer-order-status-categories', {
        	url: '/customer-order-status-categories',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.company-setup.customer-order-status-categories', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.flex-field-config', {
        	url: '/flex-field-config',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.company-setup.flex-field-config', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
		.state('app.setup.write-back-audit-log', {
        	url: '/write-back-audit-log',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.company-setup.write-back-audit-log', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
		})
        .state('app.setup.supplier-portal-config', {
        	url: '/supplier-portal-config',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.company-setup.supplier-portal-config', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.inventoryActionsPoActionConfig', {
        	url: '/po-action-config',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.company-setup.po-action-config', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.unable-to-fix-categories', {
        	url: '/unable-to-fix-categories',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.company-setup.unable-to-fix-categories', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.project-general-customer-settings', {
        	url: '/project-general-customer-settings',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.company-setup.project-general-customer-settings', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.project-saving-categories', {
        	url: '/project-saving-categories',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.company-setup.project-saving-categories', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.project-custom-fields', {
        	url: '/project-custom-fields',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.company-setup.project-custom-fields', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.workbench-customer-config', {
        	url: '/workbench-customer-config',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.company-setup.workbench-customer-config', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.cross-site-mapping-configuration', {
        	url: '/cross-site-mapping-configuration',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.company-setup.cross-site-mapping-configuration', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.dashboard-templates', {
        	url: '/dashboard-templates',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.company-setup.dashboard-templates', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
				.state('app.setup.report-templates', {
        	url: '/report-templates',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.company-setup.report-templates', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
				})
        .state('app.setup.metricsGeneral', {
        	url: '/metrics-and-goals-setup',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.site-setup.metrics-and-goals-setup', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.manageEmailAlerts', {
        	url: '/manage-email-alerts',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.company-setup.manage-email-alerts', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.emailSettings', {
        	url: '/email-settings',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.site-setup.email-settings', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.leansync-config', {
        	url: '/leansync-config',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.site-setup.leansync-config', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.leansync-add-field', {
        	url: '/leansync-add-field',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.site-setup.leansync-add-field', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.leansync-upload-file', {
        	url: '/leansync-upload-file',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.site-setup.leansync-upload-file', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.expected-data-upload-schedule', {
        	url: '/expected-data-upload-schedule',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.site-setup.expected-data-upload-schedule', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.clone-metrics', {
        	url: '/clone-metrics',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.site-setup.clone-metrics', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.view-metrics', {
        	url: '/view-metrics',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.site-setup.view-metrics', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.strategic-goals', {
        	url: '/strategic-goals',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.site-setup.strategic-goals', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.supplier-performance', {
        	url: '/supplier-performance',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.site-setup.supplier-performance', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.inventory-actions', {
        	url: '/inventory-actions',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.site-setup.inventory-actions', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.shortage-criticality', {
        	url: '/shortage-criticality',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.site-setup.shortage-criticality', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.supply-chain-general', {
        	url: '/supply-chain-setup',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.site-setup.supply-chain-setup', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.supply-chain-procurement', {
        	url: '/analytics-engine',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.site-setup.analytics-engine', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.project-general-settings', {
        	url: '/project-general-settings',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.site-setup.project-general-settings', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.project-stages', {
        	url: '/project-stages',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.site-setup.project-stages', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.project-areas', {
        	url: '/project-areas',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.site-setup.project-areas', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.project-types', {
        	url: '/project-types',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.site-setup.project-types', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.project-templates', {
        	url: '/project-templates',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.site-setup.project-templates', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.import-projects', {
        	url: '/import-projects',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.site-setup.import-projects', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.clone-projects', {
        	url: '/clone-projects',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.site-setup.clone-projects', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.factory-general-settings', {
        	url: '/factory-general-settings',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.site-setup.factory-general-settings', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.factory-order-policy-recommendations', {
        	url: '/factory-order-policy-recommendations',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.site-setup.factory-order-policy-recommendations', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.factory-line-of-balance', {
        	url: '/factory-line-of-balance',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.site-setup.factory-line-of-balance', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.supplier-late-delivery-causes', {
        	url: '/supplier-late-delivery-causes',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.site-setup.supplier-late-delivery-causes', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.supplier-whitelist', {
        	url: '/supplier-whitelist',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.site-setup.supplier-whitelist', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.value-streams', {
        	url: '/value-streams',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.site-setup.value-streams', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.project-categories', {
        	url: '/project-categories',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.site-setup.project-categories', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.workbench-configuration', {
        	url: '/workbench-configuration',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.site-setup.workbench-configuration', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.configure-metric', {
        	url: '/configure-metric',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.site-setup.configure-metric', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.createFactory', {
        	url: '/create-factory?:showAddNewCustomer',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.leandna-setup.create-factory', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.cloneSettings', {
        	url: '/clone-settings',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.leandna-setup.clone-settings', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.customerSuccessReport', {
        	url: '/customer-success-report',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.leandna-setup.customer-success-report', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.manageCache', {
        	url: '/manage-cache',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.leandna-setup.manage-cache', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.email-report', {
        	url: '/email-report',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.leandna-setup.email-report', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
				.state('app.setup.audit-log', {
        	url: '/audit-log',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.leandna-setup.audit-log', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
				})
        .state('app.setup.feature-flags', {
        	url: '/feature-flags',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.leandna-setup.feature-flags', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
        .state('app.setup.supplier-welcome-email-editor-customer', {
        	url: '/supplier-welcome-email-editor-customer',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.company-setup.supplier-welcome-email-editor-customer', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
				.state('app.dashboard.new-dashboard', {
					url: '/crud/db',
					resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.dashboard.create', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
				})
        .state('app.setup.supplier-welcome-email-editor', {
        	url: '/supplier-welcome-email-editor',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.site-setup.supplier-welcome-email-editor', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
        })
				.state('app.supply-chain.reports', {
        	url: '/reports',
        	resolve: {
        		redirectParams: function($location, redirectParamsService) {
        			redirectParamsService.putRedirectParams($location.search());
        		}
        	},
        	views: {
        		'main@': {
        			controller: function($state, $location) {
        				$state.go('app.supply-chain.report-list', $location.search());
        			},
        			controllerAs: 'redirect'
        		}
        	}
				});

		// My Account and Company Setup > Edit User share this view. react-user-management swaps in the React page.
		function userDetailsView() {
			return {
				templateProvider: ['$templateRequest', '$experiments', function ($templateRequest, $experiments) {
					return $templateRequest($experiments.isEnabled('react-user-management') ?
						'setup/user-details-react.html' : 'setup/user_form.html');
				}],
				controllerProvider: ['$experiments', function ($experiments) {
					return $experiments.isEnabled('react-user-management') ? angular.noop : 'userFormCtrl';
				}]
			};
		}
	}
})();